import { render, staticRenderFns } from "./Paragraphe.vue?vue&type=template&id=c09644aa&"
import script from "./Paragraphe.vue?vue&type=script&lang=js&"
export * from "./Paragraphe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports